import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { View } from 'foundations-components/transitional/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { Big } from 'foundations-components/transitional/components/Big';
import { DuplicateIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ToolLinkCopyButton({
  text
}) {
  return /*#__PURE__*/_jsx(CopyButton, {
    use: "link",
    value: text,
    responsive: false,
    children: /*#__PURE__*/_jsx(DuplicateIcon, {
      size: "200",
      color: "icon-core-subtle"
    })
  });
}
function ToolLink({
  isCopyable = false,
  label = '',
  onClick = () => {},
  text,
  url
}) {
  return /*#__PURE__*/_jsxs(View, {
    paddingBlockEnd: "100",
    children: [label ? /*#__PURE__*/_jsxs(View, {
      "data-test-id": "label",
      marginInlineEnd: "100",
      as: "span",
      children: [label, ":"]
    }) : null, /*#__PURE__*/_jsx(Link, {
      "data-test-id": "link",
      external: true,
      href: url,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(Big, {
        children: text
      })
    }), isCopyable ? /*#__PURE__*/_jsx(ToolLinkCopyButton, {
      text: text
    }) : null]
  });
}
export default ToolLink;